import { render, staticRenderFns } from "./SetBoxTemplate.vue?vue&type=template&id=fb29c608&scoped=true&"
import script from "./SetBoxTemplate.vue?vue&type=script&lang=js&"
export * from "./SetBoxTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb29c608",
  null
  
)

export default component.exports